<template>
  <div class="calculator-page">
    <calc-seo-intro path="/calculators/payroll-deduction" />
    <healthcare-roi-calculator :calculatorTitle="'Payroll Deduction ROI (Healthcare)'" />
  </div>
</template>

<script>
import HealthcareRoiCalculator from "../components/HealthcareROICalculator.vue";
import CalcSeoIntro from "../components/CalcSeoIntro.vue";

export default {
  name: "PayrollDeductionROI",
  components: {
    HealthcareRoiCalculator,
    CalcSeoIntro,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/app.scss';

.calculator-page {
  width: 100%;
  min-height: calc(100vh - 120px);
}
</style>

